import Vue from 'vue';  
import Router from 'vue-router';  
  
Vue.use(Router); 

const routes = [
  // 默认
  {
    path: '/',
    component: () => import('@/views/LoginSet.vue')
  },
  //登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginSet.vue')
  },

  // 布局页
  {
    path: '/afh',
    name: 'afh',
    component: () => import('@/views/Web.vue'),
   //  redirect: '/afh/home',
    children: [
      //需求合成文件
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/UploadPic.vue'),
        meta: { keepAlive: true },
        children: [
          {
            path: 'GenerateDxf',
            name: 'GenerateDxf',
            component: () => import('@/components/GenerateDxf.vue'),
          }
        ]
      },
       //AI沟通需求
      {
        path: 'chatWithAi',
        name: 'chatWithAi',
        component: () => import('@/views/ChatWithAi.vue')
      },
        //USER
      {
        path: 'umgr',
        name: 'umgr',
        component: () => import('@/views/UserManagement.vue')
      },
       //G Record
      {
        path: 'genlist',
        name: 'genlist',
        component: () => import('@/views/GenerateQueues.vue')
      },
        //灯条绘制
        {
        path: 'lspd',
        name: 'lspd',
        component: () => import('@/views/DrawLightBar.vue')
      },
      //智能客服
      {
        path: 'cstr',
        name: 'cstr',
        component: () => import('@/views/Customer.vue')
      },
      //AFH-ROUTER
      {
        path: 'arg',
        name: 'arg',
        component: () => import('@/views/AutoRouting.vue')
      },
      //AFH-PROD
      {
        path: 'Prod',
        name: 'Prod',
        component: () => import('@/views/ProductionMaterials.vue')
      },
      //下单打样列表
      {
        path: 'orderList',
        name: 'orderList',
        component: () => import('@/views/OrderList.vue')
      },
      //数据集管理
      {
        path: 'dataSetList',
        name: 'dataSetList',
        component: () => import('@/views/DataSetList.vue')
      },
      //训练任务管理
      {
        path: 'trainingTasks',
        name: 'trainingTasks',
        component: () => import('@/views/TrainingTasks.vue')
      },
      //测试任务管理
      {
        path: 'testTasks',
        name: 'testTasks',
        component: () => import('@/views/TestTasks.vue')
      },
         //模组推荐
        {
          path: 'recommendMode',
          name: 'recommendMode',
          component: () => import('@/views/RecommendMode.vue')
        },
          //项目记录
          {
            path: 'modHistory',
            name: 'modHistory',
            component: () => import('@/views/ModHistory.vue')
          },

    ]
  }
 
]

const router = new Router({  
  mode: 'history', // 使用HTML5 History模式  
  base: process.env.BASE_URL,  
  routes  
});  

router.beforeEach((to, from, next) => {  
  // 验证token，只有存在token时才能跳转到内容页  
  console.log('跳转了》》》》》》》》》》')
  const token = sessionStorage.getItem('Authorization')  
  if (!token && to.path !== '/login') { 
    next('/login')
  } else {  
    next()  
  }  
}) 

export default router
